"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPoints = exports.Point = void 0;
var _react = _interopRequireDefault(require("react"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const formatPoints = (points, variant) => {
  if (!points) {
    return null;
  }

  // variant 3 will render if there is only one dataPoint. DataPoints either render as one data point or a group of 3.
  if (points.length > 3 && variant !== "variant_3") {
    return {
      points: points.slice(0, 3),
      variant: variant
    };
  } else if (points.length < 3 && points.length > 1) {
    return {
      points: points.slice(0, 1),
      variant: "variant_3"
    };
  } else if (points.length > 1 && variant === "variant_3") {
    return {
      points: points.slice(0, 1),
      variant: "variant_3"
    };
  } else if (points.length === 1 && variant !== "variant_3") {
    return {
      points,
      variant: "variant_3"
    };
  } else {
    return {
      points,
      variant
    };
  }
};
exports.formatPoints = formatPoints;
const Point = _ref => {
  let {
    contentfulId,
    header,
    description,
    icon,
    iconSize = '48px',
    variant,
    index,
    themes
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-object-id": contentfulId,
    className: `data-point__item data-point--${variant}__item data-point--${variant}__item--${index} `
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: icon?.type,
    size: Number.isInteger(iconSize) ? `${iconSize}px` : iconSize,
    color: themes?.color || "#26292E",
    className: `data-point__icon `,
    sbProps: contentfulId ? {
      "data-sb-field-path": "dataPointIcon"
    } : null
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `data-point__text-wrapper data-point--${variant}__text-wrapper`
  }, /*#__PURE__*/_react.default.createElement("p", {
    "data-sb-field-path": contentfulId ? "header" : null,
    className: `data-point__header data-point--${variant}__header`,
    style: {
      color: themes?.color || "#26292E"
    },
    "aria-label": header,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), /*#__PURE__*/_react.default.createElement("p", {
    "data-sb-field-path": contentfulId ? "description" : null,
    className: `data-point__description data-point--${variant}__description `,
    style: {
      color: themes?.color || "#26292E"
    },
    "aria-label": description
  }, description)));
};
exports.Point = Point;